module.exports = __webpack_public_path__ + "static/media/gta-map.e7aae805.png";